<div class="table-responsive min-height">
  <table class="table card-table table-vcenter text-nowrap datatable" [class.h-100]="noUsersFound || loading">
    <thead>
      <tr>
        <th></th>
        @if (hasImpersonatorRole) {
          <th></th>
        }
        <th></th>
        <th>{{ 'admin.userTable.headers.firstName' | translate }}</th>
        <th>{{ 'admin.userTable.headers.surname' | translate }}</th>
        <th>{{ 'admin.userTable.headers.emailAddress' | translate }}</th>
        <th>{{ 'admin.userTable.headers.lastLogin' | translate }}</th>
        <th>{{ 'admin.userTable.headers.status' | translate }}</th>
        <th>{{ 'admin.userTable.headers.organisations' | translate }}</th>
      </tr>
    </thead>

    @if (loading) {
      <tbody>
        <tr>
          <td colspan="9" class="text-center">
            <div class="spinner-border"></div>
          </td>
        </tr>
      </tbody>
    }

    @if (!loading && noUsersFound) {
      <tbody>
        <tr>
          <td colSpan="9">
            <div class="empty">
              <p class="empty-title">{{ 'admin.noData' | translate }}</p>
            </div>
          </td>
        </tr>
      </tbody>
    }

    @if (!loading && !noUsersFound) {
      <tbody>
        @for (user of users; track user) {
          <app-user-grid-entry
            [user]="user"
            [loggedInUserEmail]="userEmail"
            (editUserClicked)="editUser(user)"
            (detailsClicked)="showDetails(user)"
            [readOnly]="readOnly"
            (toggleUserActiveStatusClicked)="toggleUserActiveStatus(user)"
            (resendInviteClicked)="resendInvite($event)"
            (impersonateClicked)="impersonateUser($event)"
            (deleteUserClicked)="deleteUser($event)"
            [searchTerm]="searchTerm"
            [hasImpersonatorRole]="hasImpersonatorRole"
          ></app-user-grid-entry>
        }
      </tbody>
    }
  </table>
</div>